const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:4000';

async function jsonRequest(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Request failed: ${res.status}`);
  }
  return res.headers.get('content-type')?.includes('application/json')
    ? res.json()
    : res.text();
}

export const api = {
  submitContactForm(payload) {
    return jsonRequest('/contact', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
  addToCart(productId, quantity = 1) {
    return jsonRequest('/cart', {
      method: 'POST',
      body: JSON.stringify({ productId, quantity }),
    });
  },
  toggleFavorite(productId) {
    return jsonRequest('/favorites/toggle', {
      method: 'POST',
      body: JSON.stringify({ productId }),
    });
  },
  searchProducts(query, category) {
    const params = new URLSearchParams();
    if (query) params.set('q', query);
    if (category && category !== 'всі') params.set('category', category);
    return jsonRequest(`/products/search?${params.toString()}`);
  },
};

export default api;
